import { graphql } from '~/gql';

export const SendMessageDocument = graphql(`
  mutation SendMessage($conversationId: BigInt!, $content: String!) {
    sendMessage(conversationId: $conversationId, content: $content) {
      id
      conversationId
      senderId
      content
      createdAt
      sender {
        id
        email
      }
    }
  }
`);

export const MarkConversationReadDocument = graphql(`
  mutation MarkConversationRead($conversationId: BigInt!) {
    markConversationRead(conversationId: $conversationId) {
      ...ConversationFields
    }
  }
`);
